import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"

class EditcursosAdmin extends Component {

  constructor(props) {
    super(props);
    this.state ={
      idcurso:null,
      ico: null,
      banner:null,
      nome:null,
      idcategoria:null,
      preco:null,
      precoinscricao:null,
      duracaosemestre:null,
      duracaohora:null,
      mec:null,
      objetivo:null,
      mercadotrabalho:null,
      categorias:[],
      curso:[],
      idunidade:"",
      unidades:[],
      btn:"Editar Curso",
      btndisable:false,
      status:""
    }
  }


  async componentDidMount(){
    this.loadcategorias();
    this.loadcurso ();
    this.loadunidades();
  }
 
  async loadunidades () {
    const response = await api.post("/unidades");
    this.setState({ unidades: response.data });
  }


 
  async loadcurso () {

    const response = await api.post("/curso/id", { idcurso:this.props.match.params.idcurso });
    this.setState({
      curso:response.data,
      idcurso:this.props.match.params.idcurso,
     
      nome:response.data.nome,
      idcategoria:response.data.idcategoria,
      preco:response.data.preco,
      precoinscricao:response.data.precoinscricao,
      duracaosemestre:response.data.duracaosemestre,
      duracaohora:response.data.duracaohora,
      mec:response.data.mec,
      objetivo:response.data.objetivo,
      mercadotrabalho:response.data.mercadotrabalho,
      idunidade:response.data.idunidade,
      status:response.data.status,
    })

  }



  async loadcategorias () {
    const response = await api.get("/categorias");
    this.setState({ categorias: response.data });
  }



  onChangeico = e => {
    let files = e.target.files || e.dataTransfer.files;
  if (!files.length)
  return;
  this.createImageico(files[0]);
  }
  onChangebanner = e => {

    console.log("submited img")
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length)
          return;
    this.createImagebanner(files[0]);
  }



  createImageico(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        ico: e.target.result
      })
    };
    reader.readAsDataURL(file);
  }

  createImagebanner(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        banner: e.target.result
      })
    };
    reader.readAsDataURL(file);
  }







  onFormSubmit = async e =>{
    e.preventDefault() ;
    this.setState({ btndisable:true, btn:"Aguarde",success: ""  });
    const { idcurso, ico,banner,nome,idcategoria,precoinscricao,preco,
      duracaohora,duracaosemestre,objetivo,mercadotrabalho, idunidade, status } = this.state;
      if (!nome || !idcategoria || !precoinscricao || !preco
        || !duracaohora || !duracaosemestre || !objetivo || !mercadotrabalho || !idunidade) {
          this.setState({ error: "Preencha o nome antes de editar!",
        success:null });
        this.setState({ btndisable:false, btn:"Editar Curso" });
      } else {
      const response = await api.post("/admin/curso/edit", { idunidade, ico,banner,nome,idcategoria,precoinscricao,preco,
        duracaohora,duracaosemestre,objetivo,mercadotrabalho,idcurso,status });
       

        if(response.data.id){
          this.setState({ btndisable:false, btn:"Curso Editado"  });
          this.setState({ success: "Curso Editado!" , error:null });
        }else{
          this.setState({ btndisable:false, btn:"Editar Curso" });
        }


      }
  }



  render() {

    
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <h4>Editar Curso</h4>     
        <form  onSubmit={this.onFormSubmit}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" defaultValue={this.state.curso.nome} onChange={e => this.setState({ nome: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Categoria</label>
                    <select class="browser-default custom-select"  onChange={e => this.setState({ idcategoria: e.target.value })} >
                    <option>Selecione um valor</option>

                    {this.state.categorias.map(el => (
                      
                      <option value={el.id} selected={this.state.curso.idcategoria==el.id}>{el.nome}</option>
                      
                    ))}
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Unidades</label>
                    <select class="browser-default custom-select"  onChange={e => this.setState({ idunidade: e.target.value })} >
                    <option>Selecione um valor</option>

                    {this.state.unidades.map(el => (
                      
                      <option value={el.id} selected={this.state.idunidade==el.id}>{el.nome}</option>
                      
                    ))}
                    </select>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Inscrição</label>
                    <input type="text" class="form-control" defaultValue={this.state.curso.precoinscricao} onChange={e => this.setState({ precoinscricao: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Mensalidade</label>
                    <input type="text" class="form-control" defaultValue={this.state.curso.preco} onChange={e => this.setState({ preco: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Duração Meses</label>
                    <input type="text" class="form-control" defaultValue={this.state.curso.duracaosemestre} onChange={e => this.setState({ duracaosemestre: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Duração Horas</label>
                    <input type="text" class="form-control" defaultValue={this.state.curso.duracaohora} onChange={e => this.setState({ duracaohora: e.target.value })}  />
                </div>
                <label for="exampleFormControlInput1">Objetivo</label>
                <div class="form-group">
                    
                    <textarea class="form-group col-xs-12" rows="5"  cols="53" 
                    onChange={e => this.setState({ objetivo: e.target.value })} defaultValue={this.state.curso.objetivo}></textarea>
                </div>

                <label for="exampleFormControlInput1">Público Alvo</label>
                <div class="form-group">
                    
                    <textarea class="form-group col-xs-12" rows="5"  cols="53"
                    onChange={e => this.setState({ mercadotrabalho: e.target.value })} defaultValue={this.state.curso.mercadotrabalho}  ></textarea>
                </div>


              





      <br></br>
              <label for="exampleFormControlInput1">Banner Show</label>
                <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" >Upload</span>
                </div>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" defaultValue={this.state.curso.banner}
                   onChange={this.onChangebanner}
                    aria-describedby="inputGroupFileAddon01" />
                  <label class="custom-file-label" for="inputGroupFile01">Escolher Arquivo</label>
                </div>
              </div>
              <br></br><br></br><br></br>


              <div class="form-group">
                    <label for="exampleFormControlInput1">Status</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ status: e.target.value })}>
                      <option value="1" selected={this.state.status==true}>Ativado</option>
                      <option value="0" selected={this.state.status==false}>Desativado</option>
                    </select>
              </div>


                <div class="form-group">
                <button class="btn btn-primary mb-2"  disabled={this.state.btndisable==true} >{this.state.btn}</button>
 {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(EditcursosAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/editcursos.js